import { render, staticRenderFns } from "./user-stat.vue?vue&type=template&id=6ff22462&scoped=true&"
import script from "./user-stat.vue?vue&type=script&lang=js&"
export * from "./user-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff22462",
  null
  
)

export default component.exports